import UtmCookies from './utmCookies'

export default class HubspotForm {
    constructor () {
        this.form = document.querySelector('.hubspot-form-wrap')

        if (!this.form)
            return

        this.wrap = this.form.closest('.sidebar-wrapper')

        this.openGatedContentForLeads()

        window.addEventListener('message', event => {
            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                const formId = event.data.id
                const form = document.getElementById(`hsForm_${formId}`)

                if (form) {
                    const formWrap = form.closest('.hubspot-form-wrap')
                    if (formWrap)
                        formWrap.classList.add('hubspot-form-wrap--ready')
                }
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                this.openGatedContent()
                // eslint-disable-next-line no-undef
                dataLayer.push({
                    event: 'hsFormSubmittedData',
                    formId: event.data.id,
                    submissionValues: event.data.data.submissionValues
                })
            }

            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady')
                this.updateUTMFields()
        })
    }

    updateUTMFields () {
        const fields = UtmCookies.utmParams.map(param => ({
            field: this.form.querySelector(`input[name="${param}"]`),
            param
        })).filter(item => item.field)

        // Attempt to update utm_source_first regardless of other fields
        const firstSourceField = this.form.querySelector(`input[name="${UtmCookies.firstSourceKey}"]`)
        const firstSourceValue = UtmCookies.getParamFromCookies(UtmCookies.firstSourceKey)
        if (firstSourceField && firstSourceValue)
            firstSourceField.value = firstSourceValue

        const params = UtmCookies.getParamsFromCookies()

        // Update fields if all are initially empty
        fields.forEach(({ field, param }) => {
            if (params[param])
                field.value = params[param]
        })
    }

    openGatedContentForLeads () {
        const urlParams = new URLSearchParams(window.location.search)
        const accessParam = urlParams.get('access')

        if (accessParam === 'lead') {
            const webinarGate = document.getElementById('webinar-gate')
            if (!webinarGate) return

            webinarGate.classList.add('d-none')

            if (this.wrap)
                this.wrap.classList.add('d-none')
        }
    }

    openGatedContent () {
        const webinarGate = document.getElementById('webinar-gate')

        if (!webinarGate)
            return

        webinarGate.scrollIntoView()
        webinarGate.classList.add('d-none')

        const webinarCert = document.getElementById('webinar-certificate')

        if (webinarCert) {
            webinarCert.parentElement.parentElement.classList.add('d-none')
            webinarCert.parentElement.removeChild(webinarCert)
            webinarGate.scrollIntoView()
            webinarGate.classList.add('d-none')
        }
    }
}
